import { Link } from 'react-router';
import { CONTACT_EMAIL, OPERATOR } from '../lib/legal';
import { Logo } from './Logo';

const linkClass = 'font-semibold text-ink hover:underline';

export function SiteFooter() {
  return (
    <footer className="border-t border-divider bg-card">
      <div className="mx-auto flex w-full max-w-5xl flex-wrap items-center justify-between gap-4 px-4 py-6 text-sm text-muted sm:px-6">
        <Logo size="sm" />
        <nav aria-label="Legal and contact" className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/privacy" className={linkClass}>
            Privacy
          </Link>
          <Link to="/terms" className={linkClass}>
            Terms
          </Link>
          <Link to="/developer-terms" className={linkClass}>
            Developer Terms
          </Link>
          <a href={`mailto:${CONTACT_EMAIL}`} className={linkClass}>
            {CONTACT_EMAIL}
          </a>
          <span>
            © {new Date().getFullYear()} {OPERATOR}
          </span>
        </nav>
      </div>
    </footer>
  );
}
